
require.register("core-js/library/modules/_add-to-unscopables.js", function(exports, require, module) {
  require = __makeRelativeRequire(require, {}, "core-js");
  (function() {
    module.exports = function () { /* empty */ };
  })();
});